module.exports = __webpack_public_path__ + "static/media/certifikedu.aa9984a7.svg";